import Vue from 'vue';
import User from '$src/models/userModel';
import Group from '$src/models/groupModel';

export default {
    namespaced: true,

    state: {
        id_user: null,
        globalRoles: [],
        globalRights: [],
        availableRoles: [],
    },

    getters: {
        hasRole(state) {
            return (role, entity = null) => {
                if (entity) {
                    return entity._entityAuth && entity._entityAuth.roles && entity._entityAuth.roles.includes(role);
                }
                return state.globalRoles.includes(role);
            };
        },

        hasRight(state) {
            return (right, entity = null) => {
                if (state.id_user === null) {
                    return false;
                }
                if (entity && entity._entityAuth && entity._entityAuth.rights && entity._entityAuth.rights.includes(right)) {
                    return true;
                }
                return state.globalRights.includes(right);
            };
        },

        isSame(state) {
            return id_user => {
                if (id_user instanceof Object) {
                    id_user = id_user.id_user;
                }
                return !!(state.id_user !== null && state.id_user === id_user);
            };
        },

        getIdUser(state) {
            return state.id_user;
        },

        getUser(state) {
            return User.find(state.id_user);
        },

        isAuth(state) {
            return state.id_user !== null;
        },

        isGuest(state) {
            return state.id_user === null;
        },

        getRolesSelect(state) {
            return (names = null, entity = null) => {
                let roles = state.availableRoles.slice();
                if (Array.isArray(names)) {
                    roles = roles.filter(role => names.includes(role.name) && entity === role.entity);
                }
                return roles.map(role => ({key: role.id_role, label: role.label}));
            };
        },

        getRoleById(state) {
            return (id) => state.availableRoles.find(role => role.id_role === +id);
        },

        getRoleByName(state) {
            return (name) => state.availableRoles.find(role => role.name === name);
        },
    },

    mutations: {
        setUser(state, user) {
            if (user === null) {
                state.globalRights = [];
                state.globalRoles = [];
                state.id_user = null;
            } else {
                state.globalRights = user._globalAuth.rights || [];
                state.globalRoles = user._globalAuth.roles || [];
                state.id_user = user.id_user;
            }

        },

        setAvailableRoles(state, availableRoles) {
            state.availableRoles = availableRoles;
        },
    },

    actions: {
        async login({dispatch}, {email, password}) {
            let data = await Vue.$api.request({url: '/auth/login', data: {email, password}});
            if (data.$success) {
                dispatch('setUser', data);
            }
            return {email, ...data};
        },

        async logout({}) {
            await Vue.$api.post('/auth/logout');
            window.location = '/login';
        },

        async fetchUser({dispatch}) {
            let data = await Vue.$api.get('/auth/user');

            if (data.hasOwnProperty('id_user')) {
                await dispatch('setUser', data);
            }

            if (data.hasOwnProperty('visible_wiki_groups')) {
                await Group.insertOrUpdate({data: data.visible_wiki_groups});
            }
        },

        async setUser({commit}, user) {
            commit('setUser', user);
            await User.insertOrUpdate({data: user});
        },

        async autoLogin({}, user) {
            await Vue.$api.get('/auth/login/' + user);
            window.location = '/';
        },
    },
};